import React from "react";

// The four-square Microsoft mark (brand colours), sized like GoogleIcon.
export function MicrosoftIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2.5" y="2.5" width="9" height="9" fill="#F25022" />
      <rect x="12.5" y="2.5" width="9" height="9" fill="#7FBA00" />
      <rect x="2.5" y="12.5" width="9" height="9" fill="#00A4EF" />
      <rect x="12.5" y="12.5" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}

export default MicrosoftIcon;
